import * as React from "react"
import { Box } from "@mui/material"
import { formatPercentage } from "@ui-seeker/utils"


export default function percentageMappingColumn() {
	return {
		name: 'percentageMapping', label: 'Percentage Mapping',
		options: {
			filter: false,
			customBodyRowRender: (value, row) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                { formatPercentage(value, { decimals: 0 }) }
			</Box>
		}
	}
}